import IframeResizer from '@rio-cloud/iframe-resizer';
import { RioNotifications } from '@rio-cloud/rio-notifications-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import { FormattedMessage } from 'react-intl';
import { Link, NavLink } from 'react-router';

import { config } from '../../config';
import { routes } from '../../routes/routes';
import ServiceInfo from './ServiceInfo';
import VariantNavigation from './VariantNavigation';

const navItems = [
    {
        key: 'materials',
        route: (
            <NavLink to={routes.MATERIALS} viewTransition>
                <FormattedMessage id='intl-msg:sci.materialView' defaultMessage='Material' />
            </NavLink>
        ),
    },
    {
        key: 'transports',
        route: (
            <NavLink to={routes.DEFAULT} viewTransition>
                <FormattedMessage id='intl-msg:sci.transport' defaultMessage='Transport' />
            </NavLink>
        ),
    },
];

const AppHeader = () => {
    const environment = import.meta.env.PROD ? 'production' : 'local';

    const serviceInfoItem = <ServiceInfo />;
    const notifications = <RioNotifications />;
    const userMenuItem = <DefaultUserMenu environment={environment} />;

    return (
        <ApplicationHeader
            label={<FormattedMessage id='intl-msg:sci.moduleName' defaultMessage='Inbound Monitor' />}
            appNavigator={<IframeResizer className='iFrameResizer' src={config.backend.MENU_SERVICE} />}
            homeRoute={<Link to={config.homeRoute || ''} />}
            navItems={navItems}
            actionBarItems={[serviceInfoItem, <VariantNavigation key='variant' />, notifications, userMenuItem]}
        />
    );
};

export default AppHeader;
